import { useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '../../queryKeys';

/**
 * The client's membership rows read FRESH on demand (`staleTime: 0` — the
 * global default would serve the cache), for a caller that acts on the
 * answer once instead of rendering it.
 */
export default function useFetchClientMembershipRows() {
  const queryClient = useQueryClient();
  return async ({
    clientId,
    organizationId,
  }: {
    organizationId: string;
    clientId: string;
  }) => {
    const { queryFn, queryKey } = queryKeys.memberships.fetchClientMemberships({
      clientId,
      organizationId,
    });
    const envelope = await queryClient.fetchQuery({
      queryFn,
      queryKey,
      staleTime: 0,
    });
    return envelope.data;
  };
}
